module.exports = __webpack_public_path__ + "media/bgm.84ddd1ec.mp3";